/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Copied_To_ClipboardInputs */

const en_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copied to clipboard`)
};

const es_link_copied_to_clipboard = /** @type {(inputs: Link_Copied_To_ClipboardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link copiado al portapapeles`)
};

/**
* | output |
* | --- |
* | "Link copied to clipboard" |
*
* @param {Link_Copied_To_ClipboardInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const link_copied_to_clipboard = /** @type {((inputs?: Link_Copied_To_ClipboardInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Copied_To_ClipboardInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_copied_to_clipboard(inputs)
	return es_link_copied_to_clipboard(inputs)
});